import { render } from "./ListCategory.vue?vue&type=template&id=1c7f0b1c&scoped=true"
import script from "./ListCategory.vue?vue&type=script&lang=js"
export * from "./ListCategory.vue?vue&type=script&lang=js"

import "./ListCategory.vue?vue&type=style&index=0&id=1c7f0b1c&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7f0b1c"]])

export default __exports__